import getStore from "../store/store";

export default function shouldShowPstTasks(): boolean {
    return getStore().showPstTasks;
}
